<template>
  <div id="Zbcp">
    <div class="header">
      <el-form :inline="true" class="demo-form-inline forms">
        <el-form-item label="汽车型号：" prop="carId">
          <el-select
            filterable
            v-model="queryForm.carId"
            clearable
            placeholder="--选择汽车型号--"
          >
            <el-option
              v-for="item in carModelList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产品系列：" prop="productModelId">
          <el-select
            v-model="queryForm.productModelId"
            filterable
            clearable
            remote
            reserve-keyword
            :remote-method="getProModelList"
            placeholder="--选择产品系列--"
          >
            <el-option
              v-for="item in proModelList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标签：" prop="tag">
          <el-select
            v-model="queryForm.tag"
            clearable
            placeholder="--选择标签--"
          >
            <el-option
              v-for="(item, index) in tagLists"
              :key="index"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button type="primary" @click="reset">重置</el-button>
          <el-button type="primary" @click="add">添加</el-button>
          <!-- <el-button type="primary" @click="download">打印</el-button> -->
        </el-form-item>
      </el-form>
    </div>
    <el-progress
      v-if="disabled"
      :text-inside="true"
      :stroke-width="26"
      :percentage="100"
    ></el-progress>

    <div class="table">
      <div class="content">
        <el-table :data="tableData" style="width: 100%" ref="table">
          <el-table-column prop="id" key="id" label="编号"></el-table-column>
          <el-table-column
            prop="title"
            key="title"
            label="标题"
          ></el-table-column>
          <el-table-column prop="type" key="type" label="资源类型">
            <template slot-scope="scope">
              {{
                scope.row.type == 1 ? "图片" : scope.row.type == 2 ? "视频" : ""
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="carName"
            key="carName"
            label="车型名称"
          ></el-table-column>
          <el-table-column
            prop="productModelName"
            key="productModelName"
            label="产品系列"
          ></el-table-column>
          <el-table-column
            label="创建时间"
            prop="createdAt"
            key="createdAt"
          ></el-table-column>
          <el-table-column width="150" key="todo" label="操作">
            <template slot-scope="scope">
              <span @click="bj(scope.$index, scope.row)" class="btns"
                >编辑</span
              >
              <span @click="sc(scope.$index, scope.row)" class="btns"
                >删除</span
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="button">
        <el-pagination
          background
          layout="prev, pager, next,jumper"
          @current-change="current_change"
          :total="total"
        ></el-pagination>
      </div>
    </div>

    <el-dialog
      title="修改施工案例"
      :visible.sync="editFormVisible"
      :close-on-click-modal="false"
      class="edit-form"
      :before-close="handleClose"
    >
      <el-form
        :model="editForm"
        label-width="120px"
        ref="editForm"
        :rules="rules"
      >
        <el-form-item label="标题：" prop="title">
          <el-input v-model.trim="editForm.title"></el-input>
        </el-form-item>
        <el-form-item class="ts">
          <el-form-item
            label="汽车型号："
            prop="carId"
            style="float: left; width: 50%"
          >
            <el-select
              v-model="editForm.carId"
              filterable
              placeholder="--选择汽车型号--"
            >
              <el-option
                v-for="item in carModelList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="产品系列："
            prop="productModelId"
            style="float: left; width: 50%"
          >
            <el-select
              v-model="editForm.productModelId"
              placeholder="--选择系列--"
              filterable
              clearable
              remote
              reserve-keyword
              :remote-method="getProModelList"
            >
              <el-option
                v-for="item in proModelList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form-item>
        <el-form-item label="资源类型：" prop="type">
          <el-select v-model="editForm.type" placeholder="--选择资源类型--">
            <el-option
              v-for="(item, index) in sourceTypeList"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="资源：" v-if="editForm.type == 2">
          <el-upload
            :class="imagesWF.length > 9 ? 'hide' : ''"
            action=""
            list-type="picture-card"
            accept="video/*"
            :multiple="true"
            :limit="10"
            :auto-upload="false"
            :file-list="imagesWF"
            :on-preview="handlePicturePreview"
            :on-change="handleWFOnchange"
            :on-remove="handleWFRemove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog
            :visible.sync="dialogVideoVisible"
            :before-close="newVideoClose"
          >
            <video
              width="100%"
              :src="dialogVideoUrl"
              controls
              ref="videoRef"
            ></video>
          </el-dialog>
        </el-form-item>
        <el-form-item label="资源：" v-if="editForm.type == 1">
          <el-upload
            :class="imagesWF.length > 9 ? 'hide' : ''"
            action=""
            list-type="picture-card"
            accept="image/*"
            :multiple="true"
            :limit="10"
            :auto-upload="false"
            :file-list="imagesWF"
            :on-change="handleWFOnchange"
            :on-remove="handleWFRemove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVideoVisible">
            <img width="100%" :src="dialogVideoUrl" alt="" />
          </el-dialog>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="handleCancel('editForm')">取消</el-button>
        <el-button
          :disabled="isUploadOk"
          type="primary"
          @click.native="handleUpdate('editForm')"
          >更新</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="添加施工案例"
      :visible.sync="newData"
      :close-on-click-modal="false"
      class="edit-form"
      :before-close="newClose"
    >
      <el-form
        :model="newForm"
        label-width="120px"
        ref="newForm"
        :rules="rules"
      >
        <el-form-item label="标题：" prop="title">
          <el-input v-model.trim="newForm.title"></el-input>
        </el-form-item>
        <el-form-item class="ts">
          <el-form-item
            label="汽车型号："
            prop="carId"
            style="float: left; width: 50%"
          >
            <el-select
              v-model="newForm.carId"
              filterable
              placeholder="--选择汽车型号--"
            >
              <el-option
                v-for="(item, index) in carModelList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="产品系列："
            prop="productModelId"
            style="float: left; width: 50%"
          >
            <el-select
              v-model="newForm.productModelId"
              filterable
              clearable
              remote
              reserve-keyword
              :remote-method="getProModelList"
              placeholder="--选择系列--"
            >
              <el-option
                v-for="item in proModelList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form-item>
        <el-form-item label="资源类型：" prop="type">
          <el-select v-model="newForm.type" placeholder="--选择资源类型--">
            <el-option
              v-for="(item, index) in sourceTypeList"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="资源：" v-if="newForm.type == 2">
          <el-upload
            :class="imagesWF.length > 9 ? 'hide' : ''"
            action=""
            list-type="picture-card"
            accept="video/*"
            :multiple="true"
            :limit="10"
            :auto-upload="false"
            :file-list="imagesWF"
            :on-preview="handlePicturePreview"
            :on-change="handleWFOnchange"
            :on-remove="handleWFRemove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog
            :visible.sync="dialogVideoVisible"
            :before-close="newVideoClose"
          >
            <video
              width="100%"
              :src="dialogVideoUrl"
              controls
              ref="videoRef"
            ></video>
          </el-dialog>
        </el-form-item>
        <el-form-item label="资源：" v-if="newForm.type == 1">
          <el-upload
            :class="imagesWF.length > 9 ? 'hide' : ''"
            action=""
            list-type="picture-card"
            accept="image/*"
            :multiple="true"
            :limit="10"
            :auto-upload="false"
            :file-list="imagesWF"
            :on-change="handleWFOnchange"
            :on-remove="handleWFRemove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVideoVisible">
            <img width="100%" :src="dialogVideoUrl" alt="" />
          </el-dialog>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="newCancel('newForm')">取消</el-button>
        <el-button
          :disabled="isUploadOk"
          type="primary"
          @click.native="newUpdate('newForm')"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from "dayjs";
import { getSGAL, carModel, getCPJM, getMD } from "./../axios/api";
export default {
  name: "Sgal",
  data() {
    return {
      carModelList: [], // 汽车型号
      proModelList: [], // 产品系列
      sourceTypeList: [
        { id: 1, name: "图片" },
        { id: 2, name: "视频" },
      ], // 资源类型
      tagLists: [
        { id: 1, name: "标签一" },
        { id: 2, name: "标签二" },
        { id: 3, name: "标签三" },
        { id: 4, name: "透明车衣" },
        { id: 5, name: "改色车衣" },
      ], // 添加标签
      imagesWF: [],
      dialogVideoVisible: false, // 视频预览弹框
      dialogVideoUrl: "", // 视频预览路径
      videoRef: "", // 视频
      limitUpload: 1,
      newData: false, //弹框
      queryForm: {},
      editFormVisible: false,
      editForm: {
        title: "",
        type: null,
        carId: null,
        productModelId: null,
      }, //弹框数据
      newForm: {
        title: "",
        type: null,
        carId: null,
        productModelId: null,
      },
      isUploadOk: false,
      loading: true,
      total: 0, //默认数据总数
      pagesize: 10, //每页的数据条数
      currentPage: 1, //默认开始页面
      tableData: [],
      percentage: 0,
      disabled: false,
      rules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        type: [{ required: true, message: "请输入类型", trigger: "change" }],
        carId: [
          { required: true, message: "请输入汽车型号", trigger: "change" },
        ],
        productModelId: [
          { required: true, message: "请输入产品系列", trigger: "change" },
        ],
      },
    };
  },
  methods: {
    //  获取产品系列，汽车型号
    getCarList() {
      let that = this;
      // 汽车型号
      let carData = {
        pageSize: 1000,
        pageNumber: 1,
      };
      carModel
        .getTable(carData)
        .then(function (res) {
          if (res.code !== 0) {
            that.$alert(res.message + "!", "提示", {
              confirmButtonText: "确定",
            });
          } else {
            const { list } = res.data;
            that.carModelList = list;
          }
        })
        .catch(function (res) {
          that.$alert(res.message + "!", "提示", {
            confirmButtonText: "确定",
          });
        });
    },

    // 产品系列
    getProModelList(query) {
      let that = this;
      //获取系列列表
      let proModelData = {
        pageSize: 1000,
        pageNumber: 1,
        name: query || undefined,
      };
      // console.log(data)

      getCPJM.getWFTable(proModelData).then(function (res) {
        // console.log(res);
        if (res.code !== 0) {
          that.$alert(res.message + "!", "提示", {
            confirmButtonText: "确定",
          });
        } else {
          const { list } = res.data;
          that.proModelList = list;
        }
      });
    },

    // 上传图片时的钩子
    handleWFOnchange(file, fileList) {
      var that = this;
      that.isUploadOk = true;
      const formData = new FormData();
      console.log(file);

      if (file) {
        const imgSize = file.size / 1024 / 1024;
        if (imgSize >= 10) {
          this.$message.warning("视频大于10M!");
        } else {
          console.log(file);
          formData.append("file", file.raw);

          //   return
          getSGAL
            .upload(formData)
            .then(function (res) {
              console.log(res);
              if (res.code !== 0) {
                that.$alert(res.message + "!", "提示", {
                  confirmButtonText: "确定",
                });
              } else {
                console.log(res);

                that.imagesWF.push(res.data);

                that.$message.success("上传成功!");
                that.isUploadOk = false;
              }
            })
            .catch(function (res) {});
        }
      }
    },
    // 上传图片的删除
    handleWFRemove(file, fileList) {
      if (fileList) {
        this.imagesWF = fileList;
      }
    },
    // 预览
    handlePicturePreview(file) {
      this.dialogVideoUrl = file.url;
      this.dialogVideoVisible = true;
    },

    //点击编辑
    bj: function (index, row) {
      console.log(row);
      var that = this;
      this.editFormVisible = true; //显示弹框

      let newData = [];

      row.source.map((img) => {
        let imgs = {};
        imgs.url = img;
        newData.push(imgs);
      });

      that.imagesWF = newData;

      that.editForm = row;

      that.getProModelList()
    },

    search: function () {
      this.currentPage = 1;
      this.init();
    },
    reset: function () {
      this.queryForm = {};
      this.currentPage = 1;
      this.init();
    },

    add: function () {
      this.newData = true; //显示弹框

      // 获取产品系列和汽车型号
      this.getProModelList();
    },
    // 点击关闭视频预览
    newVideoClose() {
      this.$refs.videoRef.pause(); //暂停
      this.dialogVideoVisible = false;
    },
    //点击关闭dialog
    newClose(done) {
      this.newForm.lat = "";
      this.newForm.lon = "";
      this.imagesWF = [];
      this.newData = false;
      this.$refs["newForm"].resetFields();

      // 获取产品系列和汽车型号
      this.getProModelList();
    },
    //点击取消
    newCancel(formName) {
      this.newForm.lat = "";
      this.newForm.lon = "";
      this.imagesWF = [];
      this.newData = false;
      this.$refs["newForm"].resetFields();

      // 获取产品系列和汽车型号
      this.getProModelList();
    },
    //点击添加
    newUpdate(forName) {
      var that = this;
      this.$refs["newForm"].validate((valid) => {
        if (valid) {
          // if (that.imgList.length == 0) {
          //   this.$message.warning("请上传门店照片!");
          //   return;
          // }
          let newImages = [];
          that.imagesWF.map((img) => {
            newImages.push(img.url);
          });
          var data = {
            title: that.newForm.title,
            type: that.newForm.type,
            carId: that.newForm.carId,
            productModelId: that.newForm.productModelId,
            // createdAt:moment(that.newForm.createdAt).valueOf() / 1000,
            source: newImages,
          };
          console.log(data);
          // return;
          getSGAL
            .addTable(JSON.stringify(data))
            .then(function (res) {
              if (res.code !== 0) {
                that.$alert(res.message + "!", "提示", {
                  confirmButtonText: "确定",
                });
              } else {
                that.$message.success("添加成功!");
                that.disabled = false;
                that.newData = false;
                that.newForm = {};
                that.$refs["newForm"].resetFields();
                that.imagesWF = [];
                that.init();
              }
            })
            .catch(function (res) {
              that.$alert(res.message + "!", "提示", {
                confirmButtonText: "确定",
              });
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.init();
    },

    //点击关闭dialog
    handleClose(done) {
      this.editFormVisible = false;
      this.$refs["editForm"].clearValidate();
      this.imagesWF = [];

      // 获取产品系列和汽车型号
      this.getProModelList();
    },
    //点击取消
    handleCancel: function (formName) {
      this.editFormVisible = false;
      this.$refs["editForm"].clearValidate();
      this.imagesWF = [];

      // 获取产品系列和汽车型号
      this.getProModelList();
    },
    //点击更新
    handleUpdate(forName) {
      var that = this;
      that.$refs["editForm"].validate((valid) => {
        if (valid) {
          let newImages = [];
          that.imagesWF.map((img) => {
            newImages.push(img.url);
          });
          var data = {
            title: that.editForm.title,
            type: that.editForm.type,
            carId: that.editForm.carId,
            productModelId: that.editForm.productModelId,
            source: newImages,
          };
          console.log(data);
          // return;
          getSGAL
            .editTable(data, that.editForm.id)
            .then(function (res) {
              if (res.code !== 0) {
                that.$alert(res.message + "!", "提示", {
                  confirmButtonText: "确定",
                });
              } else {
                that.$message.success("更新成功!");
                that.editFormVisible = false;
                that.$refs["editForm"].clearValidate();
                that.imagesWF = [];
                that.init();
              }
            })
            .catch(function (res) {
              that.editFormVisible = false;
              that.$refs["editForm"].clearValidate();
              // console.log(res)
              that.$alert(res.message + "!", "提示", {
                confirmButtonText: "确定",
              });
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
      //更新的时候就把弹出来的表单中的数据写到要修改的表格中

      // console.log(data)
    },
    //点击删除
    sc: function (index, row) {
      console.log(row);
      var that = this;
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          getSGAL
            .delTable({
              id: row.id,
            })
            .then(function (res) {
              if (res.code !== 0) {
                that.$alert(res.message + "!", "提示", {
                  confirmButtonText: "确定",
                });
              } else {
                that.currentPage = 1;
                that.init();
                that.$message({
                  type: "success",
                  message: "删除成功!",
                });
              }
            })
            .catch(function (res) {
              that.$message({
                type: "info",
                message: res.message,
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //重置密码
    cz: function (index, row) {
      this.editPasswordVisible = true;
      // 密码
      this.editPasswordForm.id = row.id;
    },

    init: function () {
      var that = this;
      that.loading = true;

      //获取门店列表

      var data = {
        carId: that.queryForm.carId ? that.queryForm.carId : undefined,
        productModelId: that.queryForm.productModelId
          ? that.queryForm.productModelId
          : undefined,
        tag: that.queryForm.tag ? that.queryForm.tag : undefined,
        pageSize: that.pagesize,
        pageNumber: that.currentPage,
      };

      getSGAL.getTable(data).then(function (res) {
        // console.log(res);
        if (res.code !== 0) {
          that.$alert(res.message + "!", "提示", {
            confirmButtonText: "确定",
          });
        } else {
          const { list, totalNumber } = res.data;
          list.map((lis) => {
            lis.createdAt = moment(new Date(lis.createdAt * 1000)).format(
              "YYYY-MM-DD"
            );
          });
          // console.log(list)
          that.total = totalNumber;
          that.tableData = list;
        }
      });
      // 获取产品系列和汽车型号
      that.getCarList();
      that.getProModelList();
    },
  },
  mounted() {
    var that = this;

    that.init();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"] {
  -moz-appearance: textfield;
}
#container {
  height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/page/Sgal.vue